import { create } from "zustand";

const useSyncProgressStore = create((set) => ({
  percent: "0%",
  productCategoryPercentage: "0",
  productPercentage: "0",
  promotionPercentage: "0",
  // True from the moment a Full Sync clears db.products until syncProducts()
  // has finished repopulating it. Readers that fetch products directly for a
  // popup/listing (rather than via the reactive UI) should check/wait on this
  // so they never observe the cleared-but-not-yet-refilled table — see
  // src/utils/waitForProductsSync.js.
  productsTableSyncing: false,
  setProgress: (updates) => set((state) => ({ ...state, ...updates })),
  resetProgress: () =>
    set({
      percent: "0%",
      productCategoryPercentage: "0",
      productPercentage: "0",
      promotionPercentage: "0",
      productsTableSyncing: false,
    }),
}));

export default useSyncProgressStore;
